export default {
  methods: {
    formatDate(date) {
      const options = {
        weekday: "short",
        month: "numeric",
        day: "numeric",
        year: "numeric",
      };
      const dateFormat = new Date(date).toLocaleDateString("en-US", options);
      const today = new Date().toLocaleDateString("en-US", options);
      if (dateFormat === today) {
        return "Today";
      }
      return dateFormat;
    },

    formatTime(date) {
      const time = new Date(date);
      return time.toLocaleTimeString([], {
        hour: "numeric",
        minute: "numeric",
      });
    },
  },
};
